import React, { useState } from 'react';
import {
    Row,
    Col,
    Input,
    Form,
    Button,
    AutoComplete,
    message,
    Modal,
    Tooltip
} from 'antd';
import {
    PlusOutlined,
    HomeOutlined
} from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';
import rawProvince from '../../../utils/province.json';

function CreateShipments({ customer }) {

    const [result, setResult] = useState([]);
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/shipment/', data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => form.resetFields()
                    });
                    queryClient.invalidateQueries([`/api/customer/${customer._id}`])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            // .then(values => console.log({...values,customer:customer._id}))
            .then(values => mutate({ ...values, customer: customer._id }))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    };

    const onCancelCreate = () => {
        form.resetFields();
        setOpen(false);
    }

    const handleDistrictSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.district.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleAmphoeSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.amphoe.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleProvinceSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.province.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const onSelect = info => {
        const splitTambon = info.split('/');
        form.setFieldsValue({
            sub_district: splitTambon[0],
            district: splitTambon[1],
            province: splitTambon[2],
            postalcode: splitTambon[3]
        })
    };

    const onFillAddress = () => {
        form.setFieldsValue({
            address: customer.address,
            sub_district: customer.sub_district,
            district: customer.district,
            province: customer.province,
            postalcode: customer.postalcode
        });
    }

    // console.log('customer :', customer);

    return (
        <div>
            {contextHolder}
            <Row justify="end">
                <Col>
                    <Button
                        type='primary'
                        icon={<PlusOutlined />}
                        onClick={() => setOpen(true)}
                    >เพิ่มสถานที่จัดส่ง</Button>
                    <Modal
                        open={open}
                        title="เพิ่มสถานที่จัดส่ง"
                        onCancel={onCancelCreate}
                        footer={[
                            <Button key="back" onClick={onCancelCreate}>
                                ยกเลิก
                            </Button>,
                            <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                                ตกลง
                            </Button>
                        ]}
                    >
                        <Form
                            form={form}
                            layout="vertical"
                            name='addCustomerShipment'
                        >
                            <Form.Item
                                name="name"
                                label="ชื่อ"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="address"
                                label={<>
                                    <span>ที่อยู่</span>
                                    <Tooltip placement="rightTop" title={'ใช้ที่อยู่ตามที่บันทึกไว้ก่อนหน้า'} >
                                        <Button size='small' icon={<HomeOutlined />} type='text' onClick={onFillAddress} />
                                    </Tooltip>
                                </>}
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล',
                                    },
                                ]}
                            >
                                <Input.TextArea rows={2} />
                            </Form.Item>
                            <Row gutter={[8, 8]}>
                                <Col xs={12}>
                                    <Form.Item
                                        label="ตำบล"
                                        name="sub_district"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'กรุณากรอกข้อมูล!',
                                            },
                                        ]}
                                    >
                                        <AutoComplete
                                            onSelect={onSelect}
                                            onSearch={handleDistrictSearch}
                                        >
                                            {result.map((tam) => (
                                                <AutoComplete.Option key={tam} value={tam}>
                                                    {tam}
                                                </AutoComplete.Option>
                                            ))}
                                        </AutoComplete>
                                    </Form.Item>
                                </Col>
                                <Col xs={12}>
                                    <Form.Item
                                        label="อำเภอ"
                                        name="district"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'กรุณากรอกข้อมูล!',
                                            },
                                        ]}
                                    >
                                        <AutoComplete
                                            onSelect={onSelect}
                                            onSearch={handleAmphoeSearch}
                                        >
                                            {result.map((amp) => (
                                                <AutoComplete.Option key={amp} value={amp}>
                                                    {amp}
                                                </AutoComplete.Option>
                                            ))}
                                        </AutoComplete>
                                    </Form.Item>
                                </Col>
                                <Col xs={12}>
                                    <Form.Item
                                        label="จังหวัด"
                                        name="province"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'กรุณากรอกข้อมูล!',
                                            },
                                        ]}
                                    >
                                        <AutoComplete
                                            onSelect={onSelect}
                                            onSearch={handleProvinceSearch}
                                        >
                                            {result.map((prov) => (
                                                <AutoComplete.Option key={prov} value={prov}>
                                                    {prov}
                                                </AutoComplete.Option>
                                            ))}
                                        </AutoComplete>
                                    </Form.Item>
                                </Col>
                                <Col xs={12}>
                                    <Form.Item
                                        label="รหัสไปรษณีย์"
                                        name="postalcode"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'กรุณากรอกข้อมูล!',
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Modal>
                </Col>
            </Row>


        </div>
    )
}

export default CreateShipments